'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'beer-mug-empty';
var width = 576;
var height = 512;
var aliases = ["beer"];
var unicode = 'f0fc';
var svgPathData = 'M416 64l0 287.7c0 .2 0 .4 0 .7l0 95.7-320 0 0-384 320 0zm32 384l0-86.1 128-64 0-201.9-128 0 0-64-384 0 0 448 384 0 0-32zm96-169.9l-96 48 0-198.1 96 0 0 150.1zM192 128l-32 0 0 256 32 0 0-256zm128 0l0 256 32 0 0-256-32 0zm-48 0l-32 0 0 256 32 0 0-256z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBeerMugEmpty = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;